import React, { useEffect, useState } from "react";
import useAnalytics from "./AnalyticsHook";
import WidgetPageWrapper from "./WidgetPageWrapper";
import { Spinner } from "react-bootstrap";
import MonthlySessionsChart from "./MonthlySessionsChart";

const MonthlySessionsPage = () => {
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const { FetchAnalyticsData } = useAnalytics();

  const [analyticsSessionHistories, setAnalyticsSessionHistories] = useState(
    []
  );
  // const [analyticsCurrentMonthCode, setAnalyticsCurrentMonthCode] = useState([]);
  // const [analyticsActiveUsers, setAnalyticsActiveUsers] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (cancelled) return;
      try {
        setAnalyticsLoading(true);

        var responseData = await FetchAnalyticsData();
        if (cancelled) return;

        // setAnalyticsCurrentMonthCode(responseData.currentMonthCode);
        setAnalyticsSessionHistories(responseData.sessionHistories);
        // setAnalyticsActiveUsers(responseData.activeUsers);
      } catch (error) {
        console.log(error);
      } finally {
        setAnalyticsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <WidgetPageWrapper title={"Monthly Sessions"}>
        {analyticsLoading ? (
          <Spinner />
        ) : (
          <MonthlySessionsChart
            analyticsData={analyticsSessionHistories}
            mode={"page"}
          />
        )}
      </WidgetPageWrapper>
    </>
  );
};

export default MonthlySessionsPage;
